import styled, { css } from 'styled-components';

import * as colors from 'components/common/colorConstants';
import { lowHeightScreens, smallScreens } from 'components/common/fontElements';

export const hoverColor = colors.darkGray5;

export const sharedSelectStyles = css`
  position: absolute;
  top: 0px;
  left: -2px;
  height: 48px;
  width: 2px;
  background: ${hoverColor};
`;

export const AlertSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px 17px;
  height: 48px;
  transition: background-color 0.5s;
  position: relative;
  background-color: ${(props) => props.selected && hoverColor};
  font-weight: ${(props) => props.selected && 'bold'};
  cursor: pointer;

  &:hover {
    background-color: ${hoverColor};
    &:before {
      content: '';
      display: block;
      ${sharedSelectStyles}
    }
  }

  &:before {
    content: '';
    display: ${(props) => (props.selected ? 'block' : 'none')};
    ${sharedSelectStyles}
  }
`;

export const IconAndLabel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  p {
    font-family: 'Roboto', sans-serif;
    color: ${colors.lightGray1};
    font-size: 11px;
    display: block;
    margin: 0px 0px 0px 9px;
    @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
      font-size: 9px;
    }
  }
`;

export const RelativeWrapper = styled.div`
  position: relative;
`;

export const UnreadMarker = styled.div`
  position: absolute;
  left: 29px;
  top: 26px;
  height: 15px;
  width: 15px;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 7px;
  line-height: 7px;
  padding: 0px;
  background-color: ${colors.green1};
  color: ${colors.whiteText};
  animation-name: fadeIn;
  animation-duration: 1s;
  animation-delay: 0.3s;
  animation-fill-mode: forwards;
  opacity: 0%;

  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }
    100% {
      opacity: 100%;
    }
  }
`;

export const AlertIconContainer = styled.div`
  margin-bottom: 15px;
`;

export const SeeAllButton = styled.button`
  width: 100%;
  background-color: ${(props) => (props.selected ? hoverColor : colors.black3)};
  font-weight: ${(props) => props.selected && 'bold'};
  border: 0px;
  padding: 6px 17px;
  color: ${colors.lightGray1};
  font-size: 9px;
  margin: 0px;
  text-align: left;
  outline: none;
  font-family: 'Roboto', sans-serif;
  transition: background-color 0.5s;

  &:hover {
    background-color: ${hoverColor};
  }
`;
